<p class="desc">{{ description }}</p>
<app-dynamic-form-landing
  [formSections]="formSections"
  [showButtons]="false"
  [valuesToPatch]="formValues"
  (closeCalenderEvent)="onIsClose($event)"
  (fieldValueChanged)="onFieldValueChanged()"
></app-dynamic-form-landing>
<div class="btn_container">
  <button class="btn btn-danger-outline btn-lg" (click)="onCancel()">Cancel</button>
  <button
    class="btn btn-primary btn-lg"
    (click)="onSubmit()"
    [appProgressButton]="progress"
    [buttonText]="'Save'"
    [disabled]="!enableButton"
  >
    Save
  </button>
</div>
